// @module Tavanoteam.Calculator.Calculator
define('Calculator.Selant.View'
    , [
        'calculator_sealant.tpl'

        , 'Backbone'
        , 'Backbone.View'
        , 'jQuery'
    ]
    , function (
        calculator_sealant_tpl

        , Backbone
        , BackboneView
        , jQuery
    ) {
        'use strict';

        return BackboneView.extend({

            template: calculator_sealant_tpl

            , initialize: function (options) {
                this.container = options.container;
                this.isMainPage = options.isMainPage;
            }

            , events: {
                'click [data-action="caclulate-sealant"]': 'calculateUnitsNeeded',
                'click [data-action="reset"]': 'resetAllFields'
            }

            , calculateUnitsNeeded: function calculateUnitsNeeded() {
                if (this.inModal) {
                    var sealantOutputFieldsContainer = document.getElementById('in-modal-calculator-sealant-output-fields-container');
                    sealantOutputFieldsContainer.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' });

                    //input fields
                    var widthInch = $('#in-modal-sealant-width-inch').val(),
                        widthFraction = $('#in-modal-sealant-width-fraction').val(),
                        depthInch = $('#in-modal-sealant-depth-inch').val(),
                        depthFraction = $('#in-modal-sealant-depth-fraction').val(),
                        linearFeet = $('#in-modal-sealant-linear-feat').val(),
                        estimatedWaste = $('#in-modal-sealant-estimated-waste').val();

                    //output fields
                    var cartrdige = $('#in-modal-sealant-cartridge'),
                        sausage = $('#in-modal-sealant-sausage'),
                        quartCart = $('#in-modal-sealant-quart-cart'),
                        gallon = $('#in-modal-sealant-gallon'),
                        gallonAndHalf = $('#in-modal-sealant-one-and-half-gallon'),
                        twoGallons = $('#in-modal-sealant-two-gallon');
                } else {
                    //input fields
                    var widthInch = $('#sealant-width-inch').val(),
                        widthFraction = $('#sealant-width-fraction').val(),
                        depthInch = $('#sealant-depth-inch').val(),
                        depthFraction = $('#sealant-depth-fraction').val(),
                        linearFeet = $('#sealant-linear-feat').val(),
                        estimatedWaste = $('#sealant-estimated-waste').val();

                    //output fields
                    var cartrdige = $('#sealant-cartridge'),
                        sausage = $('#sealant-sausage'),
                        quartCart = $('#sealant-quart-cart'),
                        gallon = $('#sealant-gallon'),
                        gallonAndHalf = $('#sealant-one-and-half-gallon'),
                        twoGallons = $('#sealant-two-gallon');
                }

                var totalWidth = (parseFloat(widthInch) + parseFloat(widthFraction)),
                    totalDepth = (parseFloat(depthInch) + parseFloat(depthFraction)),
                    result = (parseFloat(totalWidth) * parseFloat(totalDepth) * (linearFeet * 12)) * 0.00433,
                    resultLos = 0;

                resultLos = (parseFloat(estimatedWaste) / 100) * result;

                if (isNaN(resultLos)) {
                    result;
                } else {
                    result += resultLos;
                };

                cartrdige.val((result * 128 / 10.3).toFixed(2));
                sausage.val((result * 128 / 20).toFixed(2));
                quartCart.val((result * 4).toFixed(2));
                gallon.val(result.toFixed(2));
                gallonAndHalf.val((result / 1.5).toFixed(2));
                twoGallons.val((result / 2).toFixed(2));
            }

            , resetAllFields: function resetAllFields() {
                $('.calculator-sealant-input-fields').find('input:text').val('');
                $('.calculator-sealant-input-fields').find('select').val(0);
                $('.calculator-sealant-output-fields').find('input:text').val('');
            }

            , getContext: function getContext()
            {
                return {
                    isMainPage : this.isMainPage ? this.isMainPage : false
                }
            }
        
        });
    });
